import React from 'react';
import { downloadIcon } from '@chordbaker/design';

const DownloadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={downloadIcon.viewBox}
    fill={downloadIcon.fill}
    stroke={downloadIcon.stroke}
    strokeWidth={downloadIcon.strokeWidth}
    strokeLinecap={downloadIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
    strokeLinejoin={downloadIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
    {...props}
  >
    <path d={(downloadIcon.elements[0] as { d: string }).d} />
    <polyline points={(downloadIcon.elements[1] as { points: string }).points} />
    <line
      x1={(downloadIcon.elements[2] as { x1: number }).x1}
      y1={(downloadIcon.elements[2] as { y1: number }).y1}
      x2={(downloadIcon.elements[2] as { x2: number }).x2}
      y2={(downloadIcon.elements[2] as { y2: number }).y2}
    />
  </svg>
);

export default DownloadIcon;
